import type { ComponentProps, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const chatOutlineButtonClassName =
  'border-border/70 bg-background text-foreground shadow-none hover:bg-muted/40 dark:bg-background dark:hover:bg-muted/50';

type ChatOutlineLinkButtonProps = {
  children: ReactNode;
  className?: string;
  icon?: LucideIcon;
  size?: ComponentProps<typeof Button>['size'];
  to: ComponentProps<typeof Link>['to'];
} & Omit<ComponentProps<typeof Link>, 'children' | 'className' | 'to'>;

export function ChatOutlineLinkButton({
  children,
  className,
  icon: Icon,
  size = 'sm',
  to,
  ...linkProps
}: ChatOutlineLinkButtonProps) {
  return (
    <Button
      asChild
      className={cn(chatOutlineButtonClassName, className)}
      size={size}
      variant="outline"
    >
      <Link to={to} {...linkProps}>
        {Icon ? <Icon className="size-4 shrink-0" aria-hidden /> : null}
        {children}
      </Link>
    </Button>
  );
}
